<template> 
  <div class="editor"> 
    <!-- MENUBAR -->
    <editor-menu-bar v-if="swMenubar" :editor="editor" v-slot="{ commands, isActive, getMarkAttrs }"> 
      <div class="menubar"> 
        <button class="menubar__button" 
                :class="{ 'is-active': isActive.bold() }" 
                @click.prevent="commands.bold"> 
                <img class="icon" src="@/assets/images/tiptap/icons/bold.svg" alt="">
        </button>
        <button class="menubar__button" 
                :class="{ 'is-active': isActive.italic() }" 
                @click.prevent="commands.italic"> 
                <img class="icon" src="@/assets/images/tiptap/icons/italic.svg" alt="">
        </button> 
        <button class="menubar__button" 
                :class="{ 'is-active': isActive.strike() }" 
                @click.prevent="commands.strike"> 
                <img class="icon" src="@/assets/images/tiptap/icons/strike.svg" alt="">
        </button> 
        <button class="menubar__button" 
                :class="{ 'is-active': isActive.underline() }"
                @click.prevent="commands.underline"> 
                <img class="icon" src="@/assets/images/tiptap/icons/underline.svg" alt="">
        </button> 
        <button class="menubar__button" 
                :class="{ 'is-active': isActive.paragraph() }" 
                @click.prevent="commands.paragraph"> 
                <img class="icon" src="@/assets/images/tiptap/icons/paragraph.svg" alt="">
        </button> 
        <button class="menubar__button" 
                :class="{ 'is-active': isActive.bullet_list() }" 
                @click.prevent="commands.bullet_list"> 
                <img class="icon" src="@/assets/images/tiptap/icons/ul.svg" alt="">
        </button> 
        <button class="menubar__button" 
                :class="{ 'is-active': isActive.ordered_list() }" 
                @click.prevent="commands.ordered_list"> 
                <img class="icon" src="@/assets/images/tiptap/icons/ol.svg" alt="">
        </button> 
        <button class="menubar__button" 
                :class="{ 'is-active': isActive.blockquote() }" 
                @click.prevent="commands.blockquote"> 
                <img class="icon" src="@/assets/images/tiptap/icons/quote.svg" alt="">
        </button> 
        <button class="menubar__button" 
                @click.prevent="commands.horizontal_rule"> 
                <img class="icon" src="@/assets/images/tiptap/icons/hr.svg" alt="">
        </button> 
        <button class="menubar__button" 
                @click.prevent="showLinkMenu(getMarkAttrs('link'))" 
                :class="{ 'is-active': isActive.link() }"> 
                <!-- <span>{{ isActive.link() ? 'Update Link' : 'Add Link'}}</span> -->
                <img class="icon" src="@/assets/images/tiptap/icons/link.svg" alt="">
        </button> 
        <button class="menubar__button"
                @click="showImagePrompt(commands.image)">
                <img class="icon" src="@/assets/images/tiptap/icons/image.svg" alt="">
        </button>
        <button class="menubar__button" 
                @click="commands.createTable({rowsCount: 3, colsCount: 3, withHeaderRow: false })">
                <img class="icon" src="@/assets/images/tiptap/icons/table.svg" alt="">
        </button>
        <span v-if="isActive.table()">
            <button class="menubar__button"
                @click="commands.deleteTable">
                <img class="icon" src="@/assets/images/tiptap/icons/delete_table.svg" alt="">
            </button>
            <button class="menubar__button"
                @click="commands.addColumnBefore">
                <img class="icon" src="@/assets/images/tiptap/icons/add_col_before.svg" alt="">
            </button>
            <button class="menubar__button"
                @click="commands.addColumnAfter">
                <img class="icon" src="@/assets/images/tiptap/icons/add_col_after.svg" alt="">
            </button>
            <button class="menubar__button"
                @click="commands.deleteColumn">
                <img class="icon" src="@/assets/images/tiptap/icons/delete_col.svg" alt="">
            </button>
            <button class="menubar__button"
                @click="commands.addRowBefore">
                <img class="icon" src="@/assets/images/tiptap/icons/add_row_before.svg" alt="">
            </button>
            <button class="menubar__button"
                @click="commands.addRowAfter">
                <img class="icon" src="@/assets/images/tiptap/icons/add_row_after.svg" alt="">
            </button>
            <button class="menubar__button"
                @click="commands.deleteRow">
                <img class="icon" src="@/assets/images/tiptap/icons/delete_row.svg" alt="">
            </button>
            <button class="menubar__button"
                @click="commands.toggleCellMerge">
                <img class="icon" src="@/assets/images/tiptap/icons/combine_cells.svg" alt="">
            </button>
        </span>        
      </div> 
    </editor-menu-bar> 
    <!-- /MENUBAR -->

    <!-- MENUBUBBLE -->
    <editor-menu-bubble class="menububble" :editor="editor" @hide="hideLinkMenu" v-slot="{ commands, isActive, getMarkAttrs, menu }">
      <div class="menububble"
          :class="{ 'is-active': menu.isActive }"
          :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`">

        <form class="menububble__form" v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(commands.link, linkUrl)">
          <input class="menububble__input" type="text" v-model="linkUrl" placeholder="https://" ref="linkInput" @keydown.esc="hideLinkMenu"/>
          <button class="menububble__button" @click="setLinkUrl(commands.link, null)" type="button">
            <img class="icon" src="@/assets/images/tiptap/icons/remove.svg" alt="">
          </button>
        </form>

        <template v-else>
          <button
            class="menububble__button"
            @click="showLinkMenu(getMarkAttrs('link'))"
            :class="{ 'is-active': isActive.link() }"
          >
            <span>{{ isActive.link() ? 'Update Link' : 'Add Link'}}</span>
            <img class="icon" src="@/assets/images/tiptap/icons/link.svg" alt="">
          </button>
        </template>
      </div>
    </editor-menu-bubble>
    <!-- /MENUBUBBLE -->

    <!-- EDITOR CONTENT -->
    <editor-content class="editor__content" :editor="editor"/>
    <!-- /EDITOR CONTENT -->

  </div> 
</template>
<script> 
import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble } from 'tiptap'
import { 
  Blockquote, CodeBlock, HardBreak, Heading, HorizontalRule, 
  OrderedList, BulletList, ListItem, TodoItem, TodoList, Image,
  Table, TableHeader, TableCell, TableRow, Bold, Code, Italic, Link, Strike, Underline, History 
} from 'tiptap-extensions'

export default { 
  name: 'editor-tiptap',
  components: { 
    EditorContent, 
    EditorMenuBar,
    EditorMenuBubble
  }, 
  props: [
    'description', 
    'menubar', 
    'readOnly'
  ],
  data () { 
    return { 
      swMenubar: this.menubar, 
      linkUrl: null, 
      linkMenuIsActive: false, 
      editor: null 
    } 
  },
  mounted () { 
    this.editor = new Editor({ 
      editable: !this.readOnly, 
      extensions: [
        new Blockquote(), 
        new BulletList(), 
        new CodeBlock(), 
        new HardBreak(), 
        new Heading({ levels: [1, 2, 3] }), 
        new Link({ rel: '', target: '_blank' }), 
        new HorizontalRule(), 
        new ListItem(), 
        new OrderedList(), 
        new TodoItem(), 
        new TodoList(), 
        new Bold(), 
        new Code(), 
        new Italic(), 
        new Strike(), 
        new Underline(), 
        new History(),
        new Image(),
        new Table({
          resizable: !this.readOnly
        }),
        new TableHeader(),
        new TableCell(),
        new TableRow()
      ],
      content: this.description,
      onUpdate: ({ getHTML }) => { this.$emit('editorContent', getHTML()) } }) 
  },
  beforeDestroy () { 
    this.editor.destroy() 
  },
  methods: { 
    showLinkMenu (attrs) {
      this.linkUrl = attrs.href
      this.linkMenuIsActive = true
      this.$nextTick(() => {
        this.$refs.linkInput.focus()
      })
    },
    hideLinkMenu () {
      this.linkUrl = null
      this.linkMenuIsActive = false
    },
    setLinkUrl (command, url) {
      command({ href: url })
      this.hideLinkMenu()
    },
    showImagePrompt (command) {
      const src = prompt('Enter the url of your image here')
      if (src !== null) {
        command({ src })
      }
    }
  }
}
</script> 
<style lang="scss" scope>
.icon {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 1rem;
  height: 1rem;
  margin: 0 .3rem;
  top: -.05rem;
  fill: currentColor;

  &__svg {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    height: 100%;
  }

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

}

// svg sprite
body > svg,
.icon use > svg,
symbol {
  path,
  rect,
  circle,
  g {
    fill: currentColor;
    stroke: none;
  }

  *[d="M0 0h24v24H0z"] {
    display: none;
  }
}
</style>